var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/mea/node_modules/core-js/internals/symbol-registry-detection.js
// module id = 295
// module chunks = 0